import { LitElement, html, css } from 'lit'
import {customElement, property, query, state} from 'lit/decorators.js'
import { unsafeHTML } from 'lit/directives/unsafe-html.js'
import { v4 as uuid } from 'uuid'
import './vxc_input_dialog'
import '@shoelace-style/shoelace/dist/themes/light.css'
import '@shoelace-style/shoelace/dist/components/relative-time/relative-time'
import '@shoelace-style/shoelace/dist/components/dialog/dialog'
import '@shoelace-style/shoelace/dist/components/icon-button/icon-button'
import '@shoelace-style/shoelace/dist/components/icon/icon'
import { registerIconLibrary } from '@shoelace-style/shoelace/dist/utilities/icon-library'

import { marked } from 'marked'
marked.setOptions({ breaks: true })

const svgIcons: Record<string,string> = {
    'thumb-up': `<svg viewBox="0 -2.5 64 64" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" fill="#999999" stroke="#999999"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>Thumb-up</title> <desc>Created with Sketch.</desc> <defs> </defs> <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage"> <g id="Thumb-up" sketch:type="MSLayerGroup" transform="translate(1.000000, 2.000000)" stroke="#6B6C6E" stroke-width="2"> <path d="M18,20 L2.9,20 C0.1,20 0,22.1 0,24.8 L0,49.1 C0,51.7 0.1,53.9 2.9,53.9 L18,53.9 C20.8,53.9 20.9,51.8 20.9,49.1 L20.9,24.8 C20.9,22.2 20.8,20 18,20 L18,20 Z" id="Shape" sketch:type="MSShapeGroup"> </path> <path d="M20.7,50.3 L22.1,50.3 C25.9,50.2 28.4,56 31.3,56 L53.9,56 C56.7,56 57.3,51.8 57.2,50 C57.2,50 60.7,48.4 59.1,42 C59.3,41.9 61.1,40.2 61.1,36.9 C61.1,33.6 59.2,32 59.2,32 C59.2,32 61.1,29.9 61.1,26.8 C61.1,23.7 58.4,22 55.6,22 L47.3,22 C40.1,22 40.7,18.1 40.7,18.1 C40.7,18.1 39.9,8 37.3,3.3 C34.1,-2.5 27.7,-0.6 30.1,7 C31.9,12.6 23.8,21 20.8,23.8" id="Shape" sketch:type="MSShapeGroup"> </path> </g> </g> </g></svg>`,
    'thumb-down': `<svg viewBox="0 -2.5 64 64" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" fill="#999999" stroke="#999999"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>Thumb-down</title> <desc>Created with Sketch.</desc> <defs> </defs> <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage"> <g id="Thumb-down" sketch:type="MSLayerGroup" transform="translate(2.000000, 1.000000)" stroke="#6B6C6E" stroke-width="2"> <path d="M43,36 L58.1,36 C60.9,36 61,33.9 61,31.2 L61,6.9 C61,4.3 60.9,2.1 58.1,2.1 L43,2.1 C40.2,2.1 40.1,4.2 40.1,6.9 L40.1,31.2 C40.1,33.8 40.2,36 43,36 L43,36 Z" id="Shape" sketch:type="MSShapeGroup"> </path> <path d="M40.3,5.7 L38.9,5.7 C35.1,5.8 32.6,0 29.7,0 L7.1,0 C4.3,0 3.7,4.2 3.8,6 C3.8,6 0.3,7.6 1.9,14 C1.7,14.1 -0.1,15.8 -0.1,19.1 C-0.1,22.4 1.8,24 1.8,24 C1.8,24 -0.1,26.1 -0.1,29.2 C-0.1,32.3 2.6,34 5.4,34 L13.7,34 C20.9,34 20.3,37.9 20.3,37.9 C20.3,37.9 21.1,48 23.7,52.7 C26.9,58.5 33.3,56.6 30.9,49 C29.1,43.4 37.2,35 40.2,32.2" id="Shape" sketch:type="MSShapeGroup"> </path> </g> </g> </g></svg>`,
    'thumb-up-green': `<svg viewBox="-6.4 -6.4 76.80 76.80" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>Thumb-up</title> <desc>Created with Sketch.</desc> <defs> </defs> <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage"> <g id="Thumb-up" sketch:type="MSLayerGroup" transform="translate(1.000000, 2.000000)" stroke="#4f7a28" stroke-width="2"> <path d="M18,20 L2.9,20 C0.1,20 0,22.1 0,24.8 L0,49.1 C0,51.7 0.1,53.9 2.9,53.9 L18,53.9 C20.8,53.9 20.9,51.8 20.9,49.1 L20.9,24.8 C20.9,22.2 20.8,20 18,20 L18,20 Z" id="Shape" sketch:type="MSShapeGroup"> </path> <path d="M20.7,50.3 L22.1,50.3 C25.9,50.2 28.4,56 31.3,56 L53.9,56 C56.7,56 57.3,51.8 57.2,50 C57.2,50 60.7,48.4 59.1,42 C59.3,41.9 61.1,40.2 61.1,36.9 C61.1,33.6 59.2,32 59.2,32 C59.2,32 61.1,29.9 61.1,26.8 C61.1,23.7 58.4,22 55.6,22 L47.3,22 C40.1,22 40.7,18.1 40.7,18.1 C40.7,18.1 39.9,8 37.3,3.3 C34.1,-2.5 27.7,-0.6 30.1,7 C31.9,12.6 23.8,21 20.8,23.8" id="Shape" sketch:type="MSShapeGroup"> </path> </g> </g> </g></svg>`,
    'thumb-up-green-bold': `<svg viewBox="0 -2.5 64 64" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>Thumb-up</title> <desc>Created with Sketch.</desc> <defs> </defs> <g id="Page-1" stroke-width="3.2" fill="none" fill-rule="evenodd" sketch:type="MSPage"> <g id="Thumb-up" sketch:type="MSLayerGroup" transform="translate(1.000000, 2.000000)" stroke="#4f7a28" stroke-width="2" fill="#B9E591"> <path d="M18,20 L2.9,20 C0.1,20 0,22.1 0,24.8 L0,49.1 C0,51.7 0.1,53.9 2.9,53.9 L18,53.9 C20.8,53.9 20.9,51.8 20.9,49.1 L20.9,24.8 C20.9,22.2 20.8,20 18,20 L18,20 Z" id="Shape" sketch:type="MSShapeGroup"> </path> <path d="M20.7,50.3 L22.1,50.3 C25.9,50.2 28.4,56 31.3,56 L53.9,56 C56.7,56 57.3,51.8 57.2,50 C57.2,50 60.7,48.4 59.1,42 C59.3,41.9 61.1,40.2 61.1,36.9 C61.1,33.6 59.2,32 59.2,32 C59.2,32 61.1,29.9 61.1,26.8 C61.1,23.7 58.4,22 55.6,22 L47.3,22 C40.1,22 40.7,18.1 40.7,18.1 C40.7,18.1 39.9,8 37.3,3.3 C34.1,-2.5 27.7,-0.6 30.1,7 C31.9,12.6 23.8,21 20.8,23.8" id="Shape" sketch:type="MSShapeGroup"> </path> </g> </g> </g></svg>`,
    'thumb-down-red': `<svg viewBox="0 -2.5 64 64" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" fill="#000000" transform="matrix(1, 0, 0, 1, 0, 0)rotate(270)"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>Thumb-down</title> <desc>Created with Sketch.</desc> <defs> </defs> <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage"> <g id="Thumb-down" sketch:type="MSLayerGroup" transform="translate(2.000000, 1.000000)" stroke="#b51a00" stroke-width="2"> <path d="M43,36 L58.1,36 C60.9,36 61,33.9 61,31.2 L61,6.9 C61,4.3 60.9,2.1 58.1,2.1 L43,2.1 C40.2,2.1 40.1,4.2 40.1,6.9 L40.1,31.2 C40.1,33.8 40.2,36 43,36 L43,36 Z" id="Shape" sketch:type="MSShapeGroup"> </path> <path d="M40.3,5.7 L38.9,5.7 C35.1,5.8 32.6,0 29.7,0 L7.1,0 C4.3,0 3.7,4.2 3.8,6 C3.8,6 0.3,7.6 1.9,14 C1.7,14.1 -0.1,15.8 -0.1,19.1 C-0.1,22.4 1.8,24 1.8,24 C1.8,24 -0.1,26.1 -0.1,29.2 C-0.1,32.3 2.6,34 5.4,34 L13.7,34 C20.9,34 20.3,37.9 20.3,37.9 C20.3,37.9 21.1,48 23.7,52.7 C26.9,58.5 33.3,56.6 30.9,49 C29.1,43.4 37.2,35 40.2,32.2" id="Shape" sketch:type="MSShapeGroup"> </path> </g> </g> </g></svg>`,
    'thumb-down-red-bold': `<svg viewBox="0 -2.5 64 64" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" fill="#000000" transform="matrix(1, 0, 0, 1, 0, 0)rotate(270)"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>Thumb-down</title> <desc>Created with Sketch.</desc> <defs> </defs> <g id="Page-1" stroke-width="3.2" fill="none" fill-rule="evenodd" sketch:type="MSPage"> <g id="Thumb-down" sketch:type="MSLayerGroup" transform="translate(2.000000, 1.000000)" stroke="#b51a00" stroke-width="2" fill="#FE8672"> <path d="M43,36 L58.1,36 C60.9,36 61,33.9 61,31.2 L61,6.9 C61,4.3 60.9,2.1 58.1,2.1 L43,2.1 C40.2,2.1 40.1,4.2 40.1,6.9 L40.1,31.2 C40.1,33.8 40.2,36 43,36 L43,36 Z" id="Shape" sketch:type="MSShapeGroup"> </path> <path d="M40.3,5.7 L38.9,5.7 C35.1,5.8 32.6,0 29.7,0 L7.1,0 C4.3,0 3.7,4.2 3.8,6 C3.8,6 0.3,7.6 1.9,14 C1.7,14.1 -0.1,15.8 -0.1,19.1 C-0.1,22.4 1.8,24 1.8,24 C1.8,24 -0.1,26.1 -0.1,29.2 C-0.1,32.3 2.6,34 5.4,34 L13.7,34 C20.9,34 20.3,37.9 20.3,37.9 C20.3,37.9 21.1,48 23.7,52.7 C26.9,58.5 33.3,56.6 30.9,49 C29.1,43.4 37.2,35 40.2,32.2" id="Shape" sketch:type="MSShapeGroup"> </path> </g> </g> </g></svg>`,
    'doc': `<svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><defs><style>.a{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;}</style></defs><path class="a" d="M10.3635,4.51A1.9944,1.9944,0,0,0,8.4189,6.5043V41.5056A1.9945,1.9945,0,0,0,10.3635,43.5H37.5867a1.9944,1.9944,0,0,0,1.9944-1.9944V14.4719H31.6036a1.9945,1.9945,0,0,1-1.9446-1.9944V4.5Z"></path><line class="a" x1="29.5693" y1="4.51" x2="39.5312" y2="14.4719"></line><line class="a" x1="15.838" y1="22.928" x2="32.1121" y2="22.928"></line><line class="a" x1="15.838" y1="34.994" x2="32.1121" y2="34.994"></line><line class="a" x1="15.838" y1="28.961" x2="32.1121" y2="28.961"></line></g></svg>`,
    'email': `<svg viewBox="0 0 48 48" id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><defs><style>.cls-1{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;}</style></defs><path class="cls-1" d="M6.47,10.71a2,2,0,0,0-2,2h0V35.32a2,2,0,0,0,2,2H41.53a2,2,0,0,0,2-2h0V12.68a2,2,0,0,0-2-2H6.47Zm33.21,3.82L24,26.07,8.32,14.53"></path></g></svg>`,
    'url': `<svg viewBox="0 0 48 48" id="a" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <defs> <style>.x{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;}</style> </defs> <g id="b"> <g id="c"> <path id="d" class="x" d="m43.9115,32.1107c-2.5693,6.3076-13.5668,10.2263-24.5636,8.7526-7.575-1.0151-13.4896-4.4077-15.2594-8.7526"></path> <path id="e" class="x" d="m45.5,24c0,6.8108-9.6259,12.3321-21.5,12.3321S2.5,30.8108,2.5,24h0"></path> <path id="f" class="x" d="m43.9115,15.8893c2.5693,6.3076-4.2626,12.6156-15.2594,14.0893-10.9968,1.4737-21.9943-2.445-24.5636-8.7526-.715-1.7553-.715-3.5815,0-5.3368"></path> <path id="g" class="x" d="m38.9748,8.5725c4.8871,4.7438,2.1443,10.8618-6.126,13.665-8.2704,2.8032-18.9366,1.23-23.8236-3.5138-3.2254-3.1308-3.2254-7.0203,0-10.1511"></path> <path id="h" class="x" d="m27.3716,2.7658c6.7265,1.0681,10.6698,5.0617,8.8077,8.9199s-8.8245,6.1201-15.5509,5.052c-6.7265-1.0681-10.6698-5.0617-8.8077-8.9199,1.1847-2.4546,4.5283-4.3725,8.8077-5.052"></path> <path id="i" class="x" d="m45.5,24c0,11.8741-9.6259,21.5-21.5,21.5S2.5,35.8741,2.5,24,12.1259,2.5,24,2.5s21.5,9.6259,21.5,21.5Z"></path> <path id="j" class="x" d="m30.5389,7.2502c0,2.1047-2.9746,3.811-6.6439,3.811s-6.6439-1.7062-6.6439-3.811,2.9746-3.811,6.6439-3.811,6.6439,1.7062,6.6439,3.811Z"></path> <g id="k"> <path id="l" class="x" d="m24.3595,3.4392c.1382-.6042.2721-.927.3972-.9219h0"></path> <path id="m" class="x" d="m23.0334,45.4828c-.6781-.0272-.842-9.6674-.3661-21.532.194-4.8375.4645-9.2979.7627-12.8827"></path> <path id="n" class="x" d="m27.6062,4.0876c1.4412-.5414,2.8176-.6146,4.0465-.1392h0"></path> <path id="o" class="x" d="m16.1374,44.0517c-5.0728-1.9626-5.7119-12.531-1.4275-23.6052,1.5009-3.8794,3.4068-7.3062,5.468-10.0372"></path> <path id="p" class="x" d="m29.8626,5.5791c4.169.0652,7.9039,1.5444,10.4114,4.4933h0"></path> <path id="q" class="x" d="m7.5161,37.9277c-5.6633-6.6601-2.9212-18.2948,6.1246-25.9868,1.3819-1.175,2.7955-2.1697,4.2791-3.0225"></path> <path id="r" class="x" d="m30.5391,7.517c9.3842,2.8782,15.7161,10.734,14.698,19.0849"></path> <path id="s" class="x" d="m2.5531,21.3981c.8704-7.1395,6.8687-12.637,14.715-14.4188"></path> <path id="t" class="x" d="m29.4068,9.3786c1.9831,1.4038,3.8859,3.1337,5.6114,5.1628,7.6922,9.0457,8.9479,20.6136,2.8048,25.8374"></path> <path id="u" class="x" d="m9.9672,7.6213c2.2622-1.9237,5.2123-2.7188,8.4209-2.504"></path> <path id="v" class="x" d="m26.8086,10.675c1.7314,3.0842,3.319,6.9458,4.5217,11.245,3.199,11.4351,2.4634,21.6363-1.643,22.7851"></path> <path id="w" class="x" d="m18.1028,3.295c.8918-.2495,1.8693-.0515,2.886.5286"></path> </g> </g> </g> </g></svg>`
}

registerIconLibrary('conversation-icons', {
    resolver: (name: string) => {
        const svg = svgIcons[name];
        if (svg)    return `data:image/svg+xml,${encodeURIComponent(svg)}`
        return ''
    },
    mutator: (svg: SVGElement) => svg.setAttribute('fill', 'currentColor')
})

const toSafeHTML = (md: string) => unsafeHTML(marked.parse(md) as string) 

type InputType = 'text' | 'audio' | 'image'
type Input     = {type: InputType, content: string}
type Output    = {json: Object|null, text: string}
type Review    = { sender: string, rating: number, comment?: string }
type Attachment= {uid: string, type: string, title: string, content: string, path: string}
type Exchange  = {uid: string, input?: Input, output?: Output, attachments?: Attachment[], timestamp: string|Date, status?: string, review?: Review}
type Dialog    = Exchange[]
type ChunkType = 'start' | 'error' | 'searching' | 'thinking' | 'topic' | 'attachments' | 'data' | 'token'
type Chunk     = {uid: string, type: ChunkType,  data: any, last: boolean }

@customElement('vxc-conversation')
export class TConversation extends LitElement {
    /** CSS */
    static styles = css`
        :host {
            color: #231313;
            font-size: .9rem;
            display: flex;
            flex-direction: column;
        }

        .conversation {
            flex: 1;
            padding: 5px 10px;
            overflow-y: auto;
        }
        
        .exchange {
            display: flex;
            flex-direction: column;
            align-items: flex-end; 
        }

        .input {
            background-color: #D1EDFF;
            -webkit-border-radius: 10px 10px 0 10px;
            border-radius: 10px 10px 0 10px;
            padding: 12px 16px;
            margin: 8px 0;
            max-width: 90vw;
            align-self: flex-end;
            word-wrap: break-word;
        }

        .output {
            align-self: flex-start;
            word-wrap: break-word;
            margin: .5rem 0 .5rem 0;
        }

        .output p {
            margin: 0
        }

        sl-relative-time {
            color: #999999;
            font-size: 0.7rem;
            align-self: flex-end;
            margin-top: -.5rem;
        }

        .btn-group {
            width: 100%;
            display: flex;
            justify-content: flex-start; 
            padding-left: 20px;      
            gap: 0rem;     
            margin: 0rem 0 0 0;
        }

        .document-container {
            width: 100%;
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
            gap: 15px;
            margin: 0rem 0 2rem 0;
        }

        .document-item {
            display: flex;
            align-items: center;
            width: 250px; /* Fixed width for all items */
            padding: 2px 16px 2px 0px;
            background-color: white;
            border-radius: 12px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
            cursor: pointer;
            transition: all 0.2s ease;
            border: 1px solid #e0e0e0;
        }

        .document-item:hover {
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
            transform: translateY(-2px);
        }

        .document-icon {
            width: 32px;
            height: 32px;
            margin-right: 12px;
            flex-shrink: 0; /* Prevents icon from shrinking */
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 6px;
            font-size: 16px;
        }

        .document-name {
            flex: 1; /* Takes up remaining space */
            font-size: .8rem;
            font-weight: 500;
            color: #2d3436;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;      /* Prevents text from wrapping to next line */
            overflow: hidden;         /* Hides the overflowing text */
            text-overflow: ellipsis;  /* Adds the ... at the end */
            width: 100%; 
        }

        .waiting {
            color: #666;
            font-style: italic;
            animation: pulse 2s ease-in-out infinite;
        }

        .thumbs {
            font-size: 1.2rem;
        }

        @keyframes pulse {
            0%, 100% { opacity: 0.5; }
            50% { opacity: 1; }
        }

        @media (max-width: 768px) {
            .document-item {
                width: 100%;
                max-width: 300px;
            }
            
            .document-container {
                justify-content: left;
            }
        }

        @media (max-width: 768px) {
            .input {
                max-width: 100vw;
            }
        }
    `
    /** properties */
    @property({ type: Array                                           })  dialog:Dialog  = []
    @property({ type: Boolean, reflect: true  })  enableReview? : Boolean
    @property({ type: Boolean, reflect: true  })  enableAttachments? : Boolean
    @property({ type: Boolean, reflect: true  })  showAttachmentsContent? : Boolean
    @state() private reviewed: string = '';                 // the uid of the exchange being reviewed  
    @state() private attachment: Attachment|null = null     // attachement to view
    @query('.conversation') private conversation!: HTMLDivElement

    updated(changedProperties: Map<string | number | symbol, unknown>): void {
        super.updated(changedProperties)
        this.scrollToBottom()
        if (changedProperties.has('show-attachments-content'))
            console.log('updated', this.enableAttachments, this.enableReview, this.showAttachmentsContent)
        else console.log('no touch', this.showAttachmentsContent)
    }

    private review(xid: string, rating: number, comment?:string) {
        console.log('reviewing', xid, rating, comment)
        try {
            let exchange = this.dialog.find( x => x.uid === xid )
            if(!exchange) throw new Error('exhange not found ! weired !!')
            exchange.review = { sender: 'me', rating, comment }
            this.dialog = [...this.dialog]
            this.dispatchEvent(new CustomEvent('review', {
                bubbles: true,
                composed: true,
                detail: { xid, rating, comment }
            }))
        }
        catch(e) { console.error(e) }
    }

    private handleThumbUp(xid: string) {
        console.log('Thumb UP !!..', xid)
        this.review(xid, 5, '')
    }

    private handleThumbDown(xid: string) {
        console.log('Thumb Down !!..', xid)
        this.reviewed = xid
        console.log('this reviewed =', this.reviewed)
    }

    private handleComment(event: CustomEvent) {
        console.log('comment :', event.detail)
        this.review(this.reviewed, -5, event.detail)
    }

    private handleCloseComment(event: CustomEvent) {
        console.log('close comment', event.detail)
        this.reviewed = ''
    }

    private showAttachement(xid: string, aid: string) {
        console.log('handling attachement', aid, 'from exchange', xid)
        console.log('showAttachmentsContent', this.showAttachmentsContent)
        try {
            let exchange = this.dialog.find( x => x.uid === xid )
            if(exchange && exchange.attachments?.length) {
                let attachment = exchange.attachments.find( att => att.uid === aid )
                console.log('attachment', attachment)
                if(attachment) {
                    if(!this.showAttachmentsContent) {
                        if(attachment.path)
                            window.open(attachment.path, '_blank')
                    }
                    else this.attachment = attachment
                }
                else this.attachment = null
            }
        }
        catch(e) { console.error(e) }
    }

    private closeAttachement(event: CustomEvent) {
        this.attachment = null
    }

    scrollToBottom() {
        this.conversation.scrollTo({
            top: this.conversation.scrollHeight,
            behavior: 'smooth'
        })
    }

    public createExchange(input:Input) {
        try {
            let exchange = {uid: 'NEW', input, status: 'pending', timestamp: new Date()}
            this.dialog  = [...this.dialog, exchange]
        }
        catch(e) { console.error(e) }
    }

    public addOutput(output:Output) {
        try {
            let exchange = {uid: uuid(), output, status: 'prompt', timestamp: new Date()}
            this.dialog  = [...this.dialog, exchange]
        }
        catch(e) { console.error(e) }
    }

    public addChunk(chunk: Chunk) {
        try {
            let dialog = [...this.dialog]
            let exchange = dialog.find( x => x.uid === chunk.uid || x.uid === 'NEW')
            if(exchange) {
                exchange.uid = chunk.uid
                exchange.output = exchange.output || { json: null, text: '' } 
                switch(chunk.type) {
                    case 'start':
                        exchange.status = 'started'
                        break
                    case 'searching':
                        exchange.status = 'searching'
                        break
                    case 'attachments':
                        exchange.attachments = chunk.data as Attachment[]
                        break;
                    case 'thinking':
                        exchange.status = 'thinking'
                        break
                    case 'topic':
                        break;
                    case 'error':
                        exchange.status = 'error'
                        break;
                    case 'token':
                        exchange.status = 'answering'
                        exchange.output.text += chunk.data
                        break;
                }
                if(chunk.last)      exchange.status = 'done'
            }
            this.dialog = dialog
        }
        catch(e) { console.error(e) }
    }

    public clear() {
        this.dialog = []
    }
    
    render() {
        const dialog = this.dialog
        console.log('rendering...', dialog)
        console.log('attachment :', this.attachment)
        return html`
            <div class="conversation">

            ${dialog.map( x => {
                x.status = x.status || 'done'
                var ts = new Date(x.timestamp)
                return html`
                    <div class="exchange" id="${x.uid}">
                        ${x.input ? 
                            html`
                                <div class="input">${x.input.content}</div>
                                <sl-relative-time date="${ts.toLocaleTimeString('fr-FR')}" lang="fr-FR"></sl-relative-time>
                            `:
                            html``
                        }
                        
                        <div class="output">
                        ${
                            ['thinking', 'searching'].includes(x.status) ? 
                            html `<span class='waiting'>${x.status}</span>` : 
                            html `${toSafeHTML(x.output?.text||'')}`
                        }
                        </div>
                        ${(x.attachments?.length && this.enableAttachments) ?
                            html`
                                <div class="document-container">
                                    ${
                                        x.attachments.map( att => 
                                            html`
                                                <div class="document-item" @click=${() => this.showAttachement(x.uid, att.uid)}>
                                                    <div class="document-icon"><sl-icon name="${att.type}" library="conversation-icons"></sl-icon></div>
                                                    <div class="document-name">${att.title}</div>
                                                </div>
                                            `
                                        )
                                    }
                                </div>
                            `: ''
                        }

                        ${ (this.enableReview && x.status === 'done') ?
                            html`<div class="btn-group thumbs">
                                <sl-icon-button name="${ (x.review && x.review.rating>0) ? `thumb-up-green-bold`:`thumb-up`}" library="conversation-icons" @click=${() => this.handleThumbUp(x.uid)}></sl-icon-button>
                                <sl-icon-button name="${ (x.review && x.review.rating<0) ? `thumb-down-red-bold`:`thumb-down`}" library="conversation-icons" @click=${() => this.handleThumbDown(x.uid)}></sl-icon-button>    
                            </div>`:'' }    
                    </div>
                    ` })}
                
            ${this.reviewed?
                html`<vxc-input-dialog title="Feedback" @dlg-input=${this.handleComment} @dlg-close=${this.handleCloseComment}></vxc-input-dialog>`
                : html``
            }
            ${this.attachment?
                html`<vxc-dialog 
                        title="${this.attachment.title||'doc'}" 
                        icons='[{"name":"eye", "url":"${this.attachment.path}"}]'
                        @closed=${this.closeAttachement}
                        show>${toSafeHTML(this.attachment.content)}</vxc-dialog>`
                : html``
            }

        </div>
        `;
    }
}

declare global {
  interface HTMLElementTagNameMap {
    'vxc-conversation': TConversation
  }
}


/*
[
    {
        "uid": "d727ca00-428e-482b-88b4-fe49953f38b6",
        "type": "chat",
        "input": {
          "type": "text",
          "content": "salut"
        },
        "output": {
          "json": null,
          "text": "Salut Moine Baptiste ! Comment allez-vous aujourd'hui ?"
        },
        "timestamp": "2025-05-19T14:48:40.172Z"
    }
]

*/